import { render } from "./UpdateProjectView.vue?vue&type=template&id=393980a8"
import script from "./UpdateProjectView.vue?vue&type=script&lang=js"
export * from "./UpdateProjectView.vue?vue&type=script&lang=js"

import exportComponent from "/home/zhayrullah/projects/laravel/mawthuq/front-mawthuq/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__